/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FormatAmenityArray = {
    format: FormatAmenityArray.format;
};
export namespace FormatAmenityArray {
    export enum format {
        AMENITY_ARRAY = 'amenityArray',
    }
}

